import { FlexRow } from '@elements/Common';
import { cn } from '@skupreme/shared/ui';
import { Factory, Info } from '@phosphor-icons/react';
import { DarkPopup } from '@elements/Popup';
import { SupplierItemsHelpText } from '@utility/constants/strings';
import { Flag } from '@elements/Flag';
import type { SupplierItem } from 'types/components/item-other-suppliers';

function Supplier({
  item,
  onClick,
}: {
  item: SupplierItem;
  onClick?: (item: SupplierItem) => void;
}) {
  return (
    <div
      className={cn(
        'sk:m-0.5 sk:ml-0 sk:flex sk:items-center sk:rounded-full sk:bg-fill-tertiary sk:px-2.5 sk:py-1.25 sk:text-[10px] sk:leading-[11px] sk:font-normal',
        onClick && 'sk:cursor-pointer',
      )}
      onClick={() => onClick && onClick(item)}
    >
      {item.region ? (
        <Flag
          name={item.region}
          title={item.region}
          width={11}
          height={11}
          className="sk:mr-1!"
        />
      ) : (
        <Factory className="sk:mr-1!" />
      )}
      {item.supplier_name || item.name}
    </div>
  );
}

export function ItemOtherSuppliers({
  list,
  onClick,
}: {
  list?: SupplierItem[];
  onClick?: (item: SupplierItem) => void;
}) {
  return (list || []).length > 0 ? (
    <FlexRow className="sk:flex-wrap">
      {list!.map(item => (
        <Supplier key={item.supplier_id} item={item} onClick={onClick} />
      ))}
      {list!.length > 1 && (
        <DarkPopup trigger={<Info size={10} />} hoverable position="top center">
          {SupplierItemsHelpText.multipleSupplierInfo}
        </DarkPopup>
      )}
    </FlexRow>
  ) : (
    <></>
  );
}
